<template>
  <v-dialog v-model="dialog" scrollable persistent :max-width="dialogLargeSize ? '' : '600px'">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <img widht="14" height="14" :src="require('../../../assets/icons/edit.svg')" />
      </v-btn>
    </template>

    <v-card>
      <v-toolbar dense flat dark color="primary" v-if="!loading">
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title class="pl-0">{{ modalTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn class="mr-4" @click="resetForm" small outlined> Reiniciar </v-btn>
        <v-btn type="submit" :form="formId" small depressed light> Guardar </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-progress-circular
              v-if="loading"
              class="my-12 prd-dialog-spinner"
              :size="50"
              :color="['success', 'error', 'warning', 'info'][Math.floor(Math.random() * 4)]"
              indeterminate
            />
            <form-vjsf
              :key="formKey"
              :formId="formId"
              :formData="formData"
              @getFormData="getFormData($event)"
              @submitForm="submitForm($event)"
              style="width: 100%"
            />
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import formVjsf from "@/components/FormVjsf.vue"

export default {
  components: {
    "form-vjsf": formVjsf,
  },
  props: {
    itemId: {
      type: Number,
      required: true,
    },
    service: {
      type: Object,
      required: true,
    },
    dialogLargeSize: {
      type: Boolean,
      required: true,
    },
    dialogModelTitle: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    formKey: 0,
    formData: {
      id: null,
      model: {},
      schema: {},
      options: {},
    },
    loading: null,
  }),
  methods: {
    cancel() {
      this.dialog = false
      this.resetForm()
    },
    resetForm() {
      this.formKey += 1
    },
    getFormData() {
      this.loading = !this.loading
      this.service.getItem(this.itemId).then(response => {
        this.formData = response.data
        this.loading = !this.loading
      })
    },
    submitForm() {
      this.service
        .updateItem(this.formData.id, this.formData.model)
        .then(() => {
          this.$emit("updateTableItem")
        })
        .catch(error => {
          this.$notify({
            type: "error",
            title: this.$store.state.commonText.notification.errorTitle,
            text: this.$store.state.commonText.notification.errorText + "<br>" + error,
          })
        })
      this.dialog = false
    },
  },
  computed: {
    formId() {
      return this.service.name() + "_" + this.itemId
    },
    modalTitle() {
      let name = "#" + this.itemId
      if (this.formData.model[this.dialogModelTitle]) {
        name += " | " + this.formData.model[this.dialogModelTitle]
      }
      return name
    },
  },
}
</script>

<style lang="scss">
.prd-dialog-spinner {
  margin-left: auto;
  margin-right: auto;
}
</style>
